import Button from '@mui/material/Button';

interface WordBufferProps {
    words: readonly string[];
    selectedWord: string;
    onSelect: (word: string) => void;
}

// color="inherit" matches MUI v4's default button: inherited black text and a neutral hover
const WordBuffer = ({ words, selectedWord, onSelect }: WordBufferProps) => (
    <div>
        {words.map((word) => (
            <Button
                key={word}
                color={selectedWord.toLowerCase() === word.toLowerCase() ? 'primary' : 'inherit'}
                onClick={() => onSelect(word)}
            >
                {word}
            </Button>
        ))}
    </div>
);

export default WordBuffer;
